
angular.module('trainerWebApp.services').factory('courseSearch', ['userGridUtils', 'trackingService', function (userGridUtils, trackingService) {

  function createSearchSettings(params) {
    function createGetData(data) {
      return function () {
        return data;
      }
    }

    function fieldFilter(name) {
      return function (term) {
        return userGridUtils.filter.createFilter(userGridUtils.filter.byFields, [term, [name]]);
      }
    }

    var fieldTrackingMap = {
      allfields: trackingService.pages.usersManage.actions.searchByAllFields,
      name: trackingService.pages.usersManage.actions.searchByName,
      email: trackingService.pages.usersManage.actions.searchByEmail,
      group: trackingService.pages.usersManage.actions.searchByGroup,
      username: trackingService.pages.usersManage.actions.searchByUsername
    };

    function fieldTracking(name) {
      return function () {
        if(fieldTrackingMap[name])
          trackingService.trackEvent(params.gaPageName, fieldTrackingMap[name]);
      }
    }

    var ungroupedText = "Ungrouped users";

    function createUngroupedUsersItem() {
      return {
        id:"ungroupedusers|ungroupedusers",
        label:null,
        cssClass:'match-italic',
        text:ungroupedText,
        field:groupField,
        dataForFilter:-1,
        track:groupField.track
      };
    }

    function formatGroupResults(results, term, isSecondLevelMenu) {
      if (mfConfig.useGroupRestrictions) {
        return results;
      }

      if (results.length == 1 && results[0].children) {
        results[0].children.push(createUngroupedUsersItem());
      }
      else if (results.length > 0 || (term && ungroupedText.toLowerCase().indexOf(term.toLowerCase()) == 0)) {
        if (isSecondLevelMenu)
          results.unshift(createUngroupedUsersItem());
        else
          results.push(createUngroupedUsersItem());
      }
      return results;
    }

    var groupField = {name:'group', label:'Group', shortcut:"group", groupLabel:"Groups:", groupName:"groupGroup",
      getSuggestions:createGetData(params.groups),
      formatResults:formatGroupResults,
      createFilterAsync:function (id, cb) {
        var filter;
        if (id == -1) {
          filter = userGridUtils.filter.createFilter(userGridUtils.filter.byBooleanField, 'hasNoGroups');
        }
        else {
          var group = _.find(params.groups, function (g) {
            return g.id == id;
          });
          filter = userGridUtils.filter.createFilter(
            userGridUtils.filter.byIds,
            [group.traineeIds]);
        }
        cb(filter);
      },
      track:fieldTracking('group')};

    var fields = [
      {name:'allfields', label:null, shortcut:'allfields',
        createFilterSync:function (term) {
          return userGridUtils.filter.createFilter(userGridUtils.filter.byPersonNameEmailUserName, [term])
        },
        track:fieldTracking('allfields')},
      {name:'name', label:'Name', shortcut:"name",
        createFilterSync:function (term) {
          return userGridUtils.filter.createFilter(userGridUtils.filter.byPersonName, [term])
        },
        track:fieldTracking('name')},
      {name:'email', label:'Email', shortcut:"email", createFilterSync:fieldFilter('email'), track:fieldTracking('email')},
      {name:'username', label:'Username', shortcut:"username", createFilterSync:fieldFilter('username'), track:fieldTracking('username')},
      groupField
    ];

    return {
      fields:fields,
      setFilter:params.setFilter,
      filterHasResults:params.filterHasResults,
      gaPageName:params.gaPageName,
      notifySearchChanged:params.notifySearchChanged
    }
  }

  return {
    createSearchSettings:createSearchSettings
  }
}]);
